<template>
  <div class="trip-mini-cta">
    <vs-button class="glass-cta" @click="openTrip" :disabled="!tripDetails" :upload="isLoading">
      <img class="icon icon-left" src="../assets/icons/add_stay.png" alt="" />
      <span class="name">{{ tripDetails ? tripDetails.name : '...' }}</span>
      <img class="icon icon-right" src="../assets/icons/arrow-right.png" alt="" />
    </vs-button>
  </div>
</template>

<script>
import { apiCall } from '../utils/ApiMiddleware';

export default {
  name: 'TripMiniCTA',
  props: {
    tripId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      tripDetails: null,
      isLoading: false
    };
  },
  methods: {
    async getTrip(id) {
      this.isLoading = true;
      const response = await apiCall('GET', '/journey/' + id);
      if (response.status == 200) {
        this.tripDetails = response.data;
      } else if (response.status != 0) {
        this.$vs.notification({
          title: 'Qualcosa è andato storto!',
          text: 'Impossibile caricare il viaggio, riprova più tardi.',
          color: 'danger',
          position: 'top-right'
        });
      }
      this.isLoading = false;
    },
    openTrip() {
      const id = (this.tripDetails && this.tripDetails.id) || this.tripId;
      if (!id) return;
      this.$router.push({ name: 'Viaggio', params: { tripId: id } });
    }
  },
  watch: {
    tripId: {
      immediate: true,
      handler(n) {
        if (n != null && n !== '') {
          this.getTrip(n);
        }
      }
    }
  }
};
</script>

<style scoped>
.trip-mini-cta {
  display: inline-flex;
  align-items: center;
}

/* Glass rounded CTA (match PoiMiniCTA) */
.glass-cta {
  display: inline-flex !important;
  align-items: center;
  gap: 8px;
  margin: 0!important;
  border-radius: 999px !important;
  background: rgba(255, 255, 255, 0.55) !important;
  -webkit-backdrop-filter: saturate(150%) blur(10px);
  backdrop-filter: saturate(150%) blur(10px);
  border: 1px solid rgba(39, 48, 63, 0.12) !important;
  color: #27303f !important;
  box-shadow: 0 6px 16px rgba(16, 24, 40, 0.12);
  padding: 8px 12px !important;
  height: 36px !important;
}

.icon {
  width: 18px;
  height: 18px;
  object-fit: contain;
  display: inline-block;
}
.icon-left { margin-right: 6px; }
.icon-right { margin-left: 6px; opacity: 0.7; }

.name {
  font-size: 13px;
  white-space: nowrap;
}
</style>
